import React from 'react';
import { Shield, FileCheck, Heart, Sparkles } from 'lucide-react';
import { services } from '../mock/data';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Shield: Shield,
  FileCheck: FileCheck,
  Heart: Heart,
  Sparkles: Sparkles
};

const Services = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3B5275] mb-4">
            How We Can Help
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Whether you need an ACA marketplace plan or private off-market coverage, we help individuals, families, self-employed professionals, and small businesses navigate every step of their health insurance journey.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="border-2 border-gray-100 hover:border-[#152238] transition-all duration-300 hover:shadow-xl group cursor-pointer"
              >
                <CardContent className="p-6 space-y-4">
                  <div className="w-14 h-14 bg-[#152238] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-[#3B5275] group-hover:text-[#1a2d47] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
